export default __webpack_public_path__ + "static/media/Regras-Incentivos-Programa-de-Excelência-FY25.pdf.25212f04.pdf";